module.exports = __webpack_public_path__ + "static/unconfined-5fc440bcfd2ce4cc123798d03504f6e9.jpg";